import { jsx as u, jsxs as H } from "react/jsx-runtime";
import q, { useState as B, useCallback as $, useEffect as z, useRef as J, useLayoutEffect as T, useImperativeHandle as N } from "react";
import j from "../../utils/colors.js";
import { Wrapper as O, Accordions as Q, AccordionItem as V, Header as X, Title as Y, IconGroup as Z, IconMinus as P, IconPlus as M, Content as U } from "./styled.js";
const g = (E) => `acc-${E}`, ce = q.forwardRef(function({
  items: s = [],
  defaultActiveIndex: v = 0,
  allowMultiple: h,
  onCollapse: o,
  onExpand: l,
  expandIcon: w,
  contractIcon: D,
  disableUpdateStateOnClick: y,
  activeIndices: m,
  accordionItemRaisedOnActive: K,
  ..._
}, k) {
  const [r, f] = B(
    Array.isArray(v) ? v : [v]
  ), [A, p] = B(), [G, F] = B(!1), I = $(
    (e, t) => {
      const c = r.indexOf(t) > -1;
      if (h)
        y || f(
          c ? r.filter((n) => n !== t) : [...r, t]
        ), c && o && o(t), !c && l && l(t);
      else if (y || f(c ? [] : [t]), r.length && o && o(r[0]), !c && l && l(t), e !== null) {
        const { top: n } = e.currentTarget.getBoundingClientRect();
        p({ value: n, element: e.currentTarget });
      }
      c && r.length === 1 && document.activeElement.blur();
    },
    [r, h, y, o, l]
  );
  z(() => {
    m && f(m);
  }, [m]);
  const R = $(
    () => ({
      toggle: (e) => I(null, e),
      closeAll: () => {
        f([]), o && r.forEach((e) => {
          o(e);
        });
      },
      close: (e) => {
        f((t) => t.filter((c) => c !== e)), o && r.includes(e) && o(e);
      },
      open: (e) => {
        f((t) => h ? [...t, e] : [e]), l && !r.includes(e) && l(e);
      }
    }),
    [I, f, h, o, l, r]
  ), b = J(R());
  T(() => {
    b.current = R();
  }, [R]), N(k, () => b.current), T(() => {
    if (!A)
      return;
    const e = A.element.getBoundingClientRect().top;
    if (e < 0 && (document != null && document.scrollingElement))
      try {
        document.scrollingElement.scrollBy({ top: e - A.value });
      } catch {
      }
  }, [A]);
  const L = $(
    (e) => {
      var t, c;
      if ((t = document.activeElement) != null && t.getAttribute("data-controls")) {
        let n;
        const i = e.which;
        if (i === 33 || i === 38 ? n = s.findIndex((d) => {
          var a;
          return g(d.id) === ((a = document.activeElement) == null ? void 0 : a.getAttribute("id"));
        }) - 1 : i === 34 || i === 40 ? n = s.findIndex((d) => {
          var a;
          return g(d.id) === ((a = document.activeElement) == null ? void 0 : a.getAttribute("id"));
        }) + 1 : i === 35 ? n = s.length - 1 : i === 36 && (n = 0), n !== void 0) {
          const d = g(s[(n + s.length) % s.length].id);
          (c = document.getElementById(d)) == null || c.focus(), e.preventDefault();
        }
      }
    },
    [s]
  ), S = () => F(!0), W = () => F(!1);
  return /* @__PURE__ */ u(O, { ..._, children: /* @__PURE__ */ u(Q, { onKeyDown: L, $focused: G, children: s.map((e, t) => {
    const c = r.indexOf(t) > -1, n = e.expandIcon || w, i = e.contractIcon || D;
    return /* @__PURE__ */ H(
      V,
      {
        $active: c,
        "data-raised": K && c,
        children: [
          /* @__PURE__ */ H(
            X,
            {
              onFocus: S,
              onBlur: W,
              onClick: (d) => I(d, t),
              "aria-expanded": c,
              "data-controls": `sect-${e.id}`,
              id: g(e.id),
              children: [
                /* @__PURE__ */ u(Y, { children: typeof e.title == "function" ? e.title({ isActive: c }) : e.title }),
                /* @__PURE__ */ u(Z, { children: c ? /* @__PURE__ */ u(
                  P,
                  {
                    fill: j.brown,
                    ...i ? { as: i } : {}
                  }
                ) : /* @__PURE__ */ u(
                  M,
                  {
                    fill: j.orange,
                    ...n ? { as: n } : {}
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ u(
            U,
            {
              id: `sect-${e.id}`,
              role: "region",
              "aria-labelledby": g(e.id),
              hidden: !c,
              children: typeof e.component == "function" ? e.component({ ...b.current, isActive: c }, t) : e.component
            }
          )
        ]
      },
      e.id
    );
  }) }) });
});
export {
  ce as Accordion,
  ce as default
};
